export const deletePost = id => {
  return {
    type: "DELETE_POST",
    // IN ES6, if the property and value are the same name, you can list just one
    id
  };
};
